import { TableColumnMeta } from '/@/modules/core/table/models/TableColumnMeta';

export class BTableColumn {
  /**
   * @var {string}
   */
  label;

  /**
   * @var {string}
   */
  field;

  /**
   * @var {number|string}
   */
  width;

  /**
   * @var {boolean}
   */
  numeric;

  /**
   * @var {boolean}
   */
  centered;

  /**
   * @var {boolean}
   */
  sortable;

  /**
   * @var {boolean}
   */
  visible;

  /**
   * @var {Function}
   */
  customSort;

  /**
   * @var {boolean}
   */
  searchable;

  /**
   * @var {Function}
   */
  customSearch;

  /**
   * @var {string|number}
   */
  subheading;

  /**
   * @var {boolean}
   */
  sticky;

  /**
   * @var {boolean}
   */
  headerSelectable;

  /**
   * @var {string}
   */
  headerClass;

  /**
   * @var {string}
   */
  cellClass;

  /**
   * @var {TableColumnMeta}
   */
  meta;

  constructor(column = {}) {
    this.label = column.label;
    this.field = column.field;
    this.width = column.width || undefined;
    this.numeric = column.numeric || false;
    this.centered = column.centered || false;
    this.sortable = column.sortable ?? true;
    this.visible = column.visible || false;
    this.customSort = column.customSort || undefined;
    this.searchable = column.searchable || false;
    this.customSearch = column.customSearch || undefined;
    this.subheading = column.subheading || undefined;
    this.sticky = column.sticky || false;
    this.headerSelectable = column.headerSelectable ?? true;
    this.headerClass = column.headerClass || undefined;
    this.headerTooltipConfig = column.headerTooltipConfig || null;
    this.cellClass = column.cellClass;
    this.meta =
      column.meta ||
      new TableColumnMeta({
        tooltip: column.tooltip,
        headerTooltipConfig: column.headerTooltipConfig,
        cellRender: column.cellRender,
        format: column.format
      });
  }
}
